import { render } from "./PdfColorCodes.vue?vue&type=template&id=7afffec4"
import script from "./PdfColorCodes.vue?vue&type=script&lang=js"
export * from "./PdfColorCodes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__